export const formatCurrencyValueForInput = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const numeric = parseFloat(value);
  return Number.isNaN(numeric) ? '' : numeric.toFixed(2);
};

export const normalizeCurrencyValue = (value) => {
  if (value === '' || value === null || value === undefined) return '';

  const numeric = typeof value === 'number' ? value : parseFloat(value);
  if (Number.isNaN(numeric)) return '';

  return parseFloat(numeric.toFixed(2));
};

export const parseCurrencyText = (value, { allowNegative = false } = {}) => {
  if (value === '' || value === null || value === undefined) return '';

  const cleaned = String(value)
    .replace(allowNegative ? /[^0-9.,-]/g : /[^0-9.,]/g, '')
    .replace(',', '.');

  if (cleaned === '' || cleaned === '-' || cleaned === '.') return '';

  const parsed = parseFloat(cleaned);
  return Number.isNaN(parsed) ? '' : parsed;
};

export const getEditingString = (value) => {
  if (value === '' || value === null || value === undefined) return '';
  const numeric = parseFloat(value);
  return Number.isNaN(numeric) ? '' : numeric.toString();
};
